import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { StreamRow } from "./StreamTable";
import SelectStreamModal from "./SelectStreamModal";
import { IStreams } from "../../../../types/streams";
import apiService from "../../../../service/Api";

const StreamDownloadLinks: React.FC = () => {
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [initialStream, setInitialStream] = useState<number | "">("");

  const [streams, setStreams] = useState<IStreams[]>([]);

  useEffect(() => {
    const fetchStreams = async () => {
      try {
        const response = await apiService.get<{
          count: number;
          next: string | null;
          previous: string | null;
          results: IStreams[];
        }>("/api/streams/stream/"); // no params

        setStreams(response.data.results); // directly set results
      } catch (error) {
        console.error("Failed to fetch streams", error);
      }
    };

    fetchStreams();
  }, []); // runs once on mount

  return (
    <>
      <Paper sx={{ p: 3, borderRadius: 2, boxShadow: "0" }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", mb: 3 }}>
          Streams Waiting For DownloadLink
        </Typography>

        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          mb={2}
          mt={1}
        >
          <Button
            variant="contained"
            sx={{
              borderRadius: 2,
            }}
            onClick={() => {
              setInitialStream("");
              setIsDownloadModalOpen(true);
            }}
          >
            Add Download Link
          </Button>
        </Box>

        <StreamRow />
        {/*
        <Table>
          <TableHead sx={{ backgroundColor: reduxTheme.primary_colors?.[800] }}>
            <TableRow>
              <TableCell>STREAM NAME</TableCell>
              <TableCell>PRODUCER</TableCell>
              <TableCell>DUE DATE</TableCell>
              <TableCell>OVER DUE BY</TableCell>
              <TableCell>Link</TableCell>
              <TableCell>ACTION</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedStreams.map((stream, index) => (
              <StreamRow
                key={stream.id}
                stream={stream}
                index={index}
                theme={reduxTheme}
                onAddLink={(id) => {
                  setInitialStream(id);
                  setIsDownloadModalOpen(true);
                }}
              />
            ))}
          </TableBody>
        </Table>

        <Pagination
          currentPage={currentPage}
          pageSize={pageSize}
          totalCount={streams.length}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize}
        />
        */}

       
        
      <SelectStreamModal
          open={isDownloadModalOpen}
          onClose={() => setIsDownloadModalOpen(false)}
          onSubmit={(_data) => {
            void _data;
            setIsDownloadModalOpen(false);
          }}
          streams={streams}
          title="Streams Waiting For Download"
          initialSelectedStream={initialStream}
        /> 
      </Paper>
    </>
  );
};

export default StreamDownloadLinks;
